import httPoison from './elixir/httPoison';
import elixirUnitTest from './elixir/unitTest';
import apolloHook from './javascript/apolloHook';

const snippets = [apolloHook, httPoison, elixirUnitTest];

export default snippets;
